import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Table, Input, Popconfirm } from 'antd';
@inject('sysStore')
@observer
class Main extends React.Component {
  static defaultProps = {
    conPrefixCls: 'sys-user',
    prefixCls: 'sys-sysManager',
  }
  componentDidMount() {
    const { sysStore: { init, getGenre } } = this.props;
    init();
    getGenre();
  }
  getColumns = () => {
    const { conPrefixCls, sysStore: { init, addGenre, getGenre, editGenre, delGenre } } = this.props;
    return [
      {
        title: 'id', dataIndex: 'g_id', key: 'g_id', render: (text) => {
          return text === '-1' ? '-' : text;
      } },
      {
        title: '名称', dataIndex: 'name', key: 'name', render: (text, record) => {
          return (<Input value={text} onChange={(e) => {
            const params = { name: e.target.value };
            const id = record.id;
            const { sysStore: { setMobxState, genreList } } = this.props;
            const res = toJS(genreList).map(v => (v.id === id ? { ...v, ...params, } : v));
            setMobxState({ genreList: res });
          }} />);
      } },
      { title: '排序', dataIndex: 'g_order', key: 'g_order', render: (text, record) => {
        return (<Input value={text} onChange={(e) => {
          const params = { g_order: e.target.value };
          const id = record.id;
          const { sysStore: { setMobxState, genreList } } = this.props;
          const res = toJS(genreList).map(v => (v.id === id ? { ...v, ...params, } : v));
          setMobxState({ genreList: res });
        }} />);
    }  },
      {
        title: '操作', dataIndex: 'op', key: 'op', render: (text, record) => {
          const disabled = record.g_order === '' || record.name === '';
          return record.g_id === '-1' ? (<div className={`${conPrefixCls}-joinList-btn`}>
            <span className={`${disabled && `${conPrefixCls}-joinList-btn-disabled`}`} onClick={() => {
              if (!disabled) {
                addGenre({ gname: record.name, gorder: record.g_order }).then(() => {
                  init();
                  getGenre();
                });
              }
            }}>添加</span>
          </div>) : (<div className={`${conPrefixCls}-joinList-btn`}>
              <span onClick={() => {
                editGenre({ gid: record.g_id, gname: record.name, gorder: record.g_order }).then(() => {
                  init();
                  getGenre();
                });
            }}>修改</span>
              <Popconfirm title="确定删除吗？" onConfirm={() => {
                delGenre({ gid: record.g_id, gorder: record.g_order }).then(() => {
                  init();
                  getGenre();
                });
            }}><span>删除</span></Popconfirm>
          </div>)
        }
      }
    ];
  }
  onTableChange = (current, pageSize) => {
    const { sysStore: { getGenre, setMobxState } } = this.props;
    setMobxState({ current, pageSize });
    getGenre({ current, pageSize });
  }
  render() {
    const { conPrefixCls, sysStore: { genreList, loading, pageSize, current } } = this.props;
    const total = toJS(genreList).length;
    return (
      <div className={`${conPrefixCls}`}>
        <Table
          rowKey="id"
          loading={loading}
          dataSource={toJS(genreList)}
          columns={this.getColumns()}
          pagination={{
            total,
            pageSize: pageSize,
            current: current,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: total => (<span>共{total}条</span>),
            onChange: this.onTableChange,
            onShowSizeChange: (page, size) => this.onTableChange(1, size),
          }} />
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/sys/sysManager/Module.js